<template>
  <div class="page-container">
    <MyHeader></MyHeader>
    <router-view class="content"></router-view>
    <MyFooter></MyFooter>
    <Record></Record>
    <BackTop></BackTop>
  </div>
</template>

<script>
import MyHeader from "@/components/common/header";
import MyFooter from "@/components/common/footer";
import Record from "@/components/common/record";
import BackTop from "@/components/common/back-top";
export default {
  name: "index",
  methods: {},
  components: { MyHeader, MyFooter, Record, BackTop },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
